$(document).ready(function() {
	const $mainMenu = $('.pl_main-menu-wrapper');
	if ($mainMenu.length) {
		const getStickyOffset = () => {
			$mainMenu.removeClass('is-sticky');
			const offset = $mainMenu.offset().top;
			if (window.scrollY >= offset) {
				$mainMenu.addClass('is-sticky');
			}
			return offset;
		};

		let stickyOffset = getStickyOffset();

		const onScroll = () => {
			if (window.scrollY >= stickyOffset) {
				$mainMenu.addClass('is-sticky');
			} else {
				$mainMenu.removeClass('is-sticky');
			}
		};

		$(window).on('scroll', onScroll);
		$(window).on('resize', () => {
			stickyOffset = getStickyOffset();
			onScroll();
		});
	}

	// Selecciona el elemento <p> con id="menu"
	var menuElement = document.getElementById('menu-navesid');

	// Agrega un event listener que se activa cuando se hace clic en el elemento
	menuElement.addEventListener('click', function() {
		// Alterna el contenido del elemento entre "Menu" y "Cerrar"
		if (menuElement.textContent === 'MENÚ') {
			const dropdownPr = $('.pl_nav_dropdown');
			dropdownPr.each(function() {
				const navItems = $('.pl_nav-item-main');
				navItems.each(function() {
					$(this).removeClass('d-none');
				});
				const navDrop = $('.nav-link.dropdown-toggle');
				navDrop.each(function() {
					$(this).removeClass('d-none');
				});
			});
			$('.pl_menu_item_body_m.show').dropdown('toggle');
		}
		menuElement.textContent =
			menuElement.textContent === 'MENÚ' ? 'CERRAR' : 'MENÚ';
	});

	const dropdownPr = $('.pl_nav_dropdown');
	dropdownPr.each(function() {
		$(this).on('shown.bs.dropdown', () => {
			const navItems = $('.pl_nav-item-main');
			navItems.each(function() {
				$(this).addClass('d-none');
			});

			const navDrop = $('.nav-link.dropdown-toggle');
			navDrop.each(function() {
				$(this).addClass('d-none');
			});
		});
		$(this).on('hidden.bs.dropdown', () => {
			const navItems = $('.pl_nav-item-main');
			navItems.each(function() {
				$(this).removeClass('d-none');
			});
			const navDrop = $('.nav-link.dropdown-toggle');
			navDrop.each(function() {
				$(this).removeClass('d-none');
			});
		});
	});

	const backDropdown = $('.pl_js-ctaback');
	backDropdown.each(function() {
		$(this).click(function() {
			$('.pl_menu_item_body_m.show').dropdown('toggle');
		});
	});

	$('.dropdown-toggle').each(function() {
		$(this).mouseleave(function() {
			$(this).blur();
		});
	});
});
